// Documentation : https://splidejs.com/documents/

(function () {
    class Slider {
        constructor(el) {
            this.el = el;
            this.slider = undefined;
            this.config = {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                arrowPath: '',
                arrows: true,
                gap: 32,
                padding: {
                    left: 32,
                    right: 32
                },
                pagination: true,
                lazyLoad: 'nearby',
                preloadPages: 1,
                focus: 'center',
                mediaQuery: 'min',
                easing: 'cubic-bezier(0.25,0.46,0.45,0.94)',
                breakpoints: {
                    640: {
                        padding: {
                            left: 160,
                            right: 160
                        },
                    },
                },
                i18n: {
                    prev: 'Diapositive précédente',
                    next: 'Diapositive  suivante',
                    first: 'Aller à la première diapositive',
                    last: 'Aller à la dernière diapositive',
                    slideX: 'Aller à la diapositive %s',
                    slideLabel: '%s sur %s',
                    select: 'Sélectionnez une diapositive à afficher',
                },
            };
        }
        init() {
            this.manageSlider();
            window.addEventListener('resize', () => {
                this.manageSlider();
            });
        }
        manageSlider() {
            this.createSlider();
        }
        createSlider() {
            if (typeof this.slider === 'undefined') {
                this.slider = new Splide(this.el, this.config).mount();
                this.slider.Components.Elements.slides[0].classList.add('init');

                this.slider.on('move', (next, prev) => {
                    const nextEl = this.slider.Components.Elements.slides[next];
                    const prevEl = this.slider.Components.Elements.slides[prev];
                    this.slider.Components.Elements.slides[0].classList.remove(
                        'init');
                    nextEl.classList.add('animate');
                    prevEl.classList.remove('animate');
                });
            }
        }
        deleteSlider() {
            if (typeof this.slider !== 'undefined') {
                this.slider.destroy();
                this.slider = undefined;
            }
        }
    }
    class FocusSlider extends Slider {
        constructor(el) {
            super(el);
            this.config = {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                gap: 16,
                padding: {
                    left: 32,
                    right: 32
                },
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                preloadPages: 1,
                focus: 'center',
                mediaQuery: 'min',
                breakpoints: {
                    480: {
                        perPage: 1,
                        padding: {
                            left: 48,
                            right: 48
                        },
                    },
                },
                i18n: {
                    prev: 'Diapositive précédente',
                    next: 'Diapositive  suivante',
                    first: 'Aller à la première diapositive',
                    last: 'Aller à la dernière diapositive',
                    slideX: 'Aller à la diapositive %s',
                    slideLabel: '%s sur %s',
                    select: 'Sélectionnez une diapositive à afficher',
                },
            };
        }
        manageSlider() {
            if (window.innerWidth <= 640) {
                this.createSlider();
            } else {
                this.deleteSlider();
            }
        }
    }

    class ArticlesSlider extends Slider {
        constructor(el) {
            super(el);
            this.config = {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                gap: 16,
                padding: {
                    left: 32,
                    right: 32
                },
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                preloadPages: 1,
                focus: 'center',
                mediaQuery: 'max',
                breakpoints: {
                    480: {
                        perPage: 1,
                        //padding: { left: 48, right: 48 },
                        padding: {
                            left: 0,
                            right: 0
                        },
                    },
                },
                i18n: {
                    prev: 'Diapositive précédente',
                    next: 'Diapositive  suivante',
                    first: 'Aller à la première diapositive',
                    last: 'Aller à la dernière diapositive',
                    slideX: 'Aller à la diapositive %s',
                    slideLabel: '%s sur %s',
                    select: 'Sélectionnez une diapositive à afficher',
                },
            };
        }
        manageSlider() {
            if (window.innerWidth <= 640) {
                this.createSlider();
            } else {
                this.deleteSlider();
            }
        }
    }

    class ProduitsSlider extends Slider {
        constructor(el) {
            super(el);
            this.config = {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                gap: 16,
                padding: {
                    left: 32,
                    right: 32
                },
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                preloadPages: 1,
                focus: 'center',
                mediaQuery: 'min',
                breakpoints: {
                    480: {
                        perPage: 1,
                        padding: {
                            left: 48,
                            right: 48
                        },
                    },
                },
                i18n: {
                    prev: 'Diapositive précédente',
                    next: 'Diapositive  suivante',
                    first: 'Aller à la première diapositive',
                    last: 'Aller à la dernière diapositive',
                    slideX: 'Aller à la diapositive %s',
                    slideLabel: '%s sur %s',
                    select: 'Sélectionnez une diapositive à afficher',
                },
            };
        }
        manageSlider() {
            if (window.innerWidth <= 640) {
                this.createSlider();
            } else {
                this.deleteSlider();
            }
        }
    }

    class FluxrssSlider extends Slider {
        constructor(el) {
            super(el);
            this.config = {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                gap: 16,
                padding: {
                    left: 32,
                    right: 32
                },
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                preloadPages: 1,
                focus: 'center',
                mediaQuery: 'min',
                breakpoints: {
                    480: {
                        perPage: 1,
                        padding: {
                            left: 48,
                            right: 48
                        },
                    },
                },
                i18n: {
                    prev: 'Article précédent',
                    next: 'Article  suivant',
                    first: 'Aller au premier article',
                    last: 'Aller au dernier article',
                    slideX: "Aller à l'article %s",
                    slideLabel: '%s sur %s',
                    select: 'Sélectionnez un article à afficher',
                },
            };
        }
        manageSlider() {
            if (window.innerWidth <= 640) {
                this.createSlider();
            } else {
                this.deleteSlider();
            }
        }
    }

    class ProjetsSlider extends Slider {
        constructor(el) {
            super(el);
            this.config = {
                type: 'slide',
                perPage: 3,
                perMove: 1,
                gap: 0,
                padding: {
                    left: 0,
                    right: 0
                },
                arrows: false,
                pagination: false,
                lazyLoad: 'nearby',
                preloadPages: 1,
                mediaQuery: 'max',
                breakpoints: {
                    640: {
                        perPage: 1,
                        padding: {
                            left: 48,
                            right: 48
                        },
                    },
                },
                i18n: {
                    prev: 'Projet précédent',
                    next: 'Projet  suivant',
                    first: 'Aller au premier projet',
                    last: 'Aller à la dernier projet',
                    slideX: 'Aller au projet %s',
                    slideLabel: '%s sur %s',
                    select: 'Sélectionnez un projet à afficher',
                },
            };
        }
        manageSlider() {
            this.createSlider();
        }
    }

    class HomeSlider extends Slider {
        constructor(el) {
            super(el);
            this.config = {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                arrowPath: '',
                arrows: false,
                autoWidth: false,
                gap: 0,
                padding: {
                    left: 0,
                    right: 0
                },
                pagination: true,
                lazyLoad: 'nearby',
                preloadPages: 1,
                focus: 'center',
                mediaQuery: 'min',
                easing: 'cubic-bezier(0.25,0.46,0.45,0.94)',
                i18n: {
                    prev: 'Diapositive précédente',
                    next: 'Diapositive  suivante',
                    first: 'Aller à la première diapositive',
                    last: 'Aller à la dernière diapositive',
                    slideX: 'Aller à la diapositive %s',
                    slideLabel: '%s sur %s',
                    select: 'Sélectionnez une diapositive à afficher',
                },
            };
        }
        manageSlider() {
            this.createSlider();
        }
    }

    class MissionsSlider extends Slider {
        constructor(el) {
            super(el);
            this.config = {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                arrowPath: '',
                arrows: false,
                gap: 48,
                padding: {
                    left: 20,
                    right: 20
                },
                pagination: false,
                lazyLoad: 'nearby',
                preloadPages: 1,
                mediaQuery: 'min',
                easing: 'cubic-bezier(0.25,0.46,0.45,0.94)',
                i18n: {
                    prev: 'Mission précédente',
                    next: 'Mission  suivante',
                    first: 'Aller à la première mission',
                    last: 'Aller à la dernière mission',
                    slideX: 'Aller à la mission %s',
                    slideLabel: '%s sur %s',
                    select: 'Sélectionnez une mission à afficher',
                },
            };
        }
        manageSlider() {
            this.createSlider();
        }
    }

    class QuizzSlider extends Slider {
        constructor(el) {
            super(el);
            this.config = {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                arrowPath: '',
                arrows: false,
                gap: 48,
                padding: {
                    left: 20,
                    right: 20
                },
                pagination: false,
                lazyLoad: 'nearby',
                preloadPages: 1,
                mediaQuery: 'min',
                easing: 'cubic-bezier(0.25,0.46,0.45,0.94)',
                i18n: {
                    prev: 'Diapositive précédente',
                    next: 'Diapositive  suivante',
                    first: 'Aller à la première diapositive',
                    last: 'Aller à la dernière diapositive',
                    slideX: 'Aller à la diapositive %s',
                    slideLabel: '%s sur %s',
                    select: 'Sélectionnez une diapositive à afficher',
                },
            };
        }
        manageSlider() {
            //this.createSlider();
        }
    }

    class Onglet extends Slider {
        constructor(el) {
            super(el);
            this.tabsSlider = undefined;
            this.tabs = el.querySelector('.onglets__tabs');
            this.tabsItems = [...this.tabs.querySelectorAll('.splide__list > li')];
            this.tabsNumber = this.tabsItems.length;
            this.tabs.config = {
                type: 'slide',
                perPage: this.tabsNumber,
                perMove: 1,
                arrows: false,
                pagination: false,
                lazyLoad: 'nearby',
                preloadPages: 1,
                mediaQuery: 'max',
                drag: false,
                isNavigation: true,
                easing: 'cubic-bezier(0.25,0.46,0.45,0.94)',
                breakpoints: {
                    640: {
                        perPage: 1,
                        fixedWidth: '230px',
                        drag: true,
                        padding: {
                            left: 0,
                            right: '20%'
                        },
                    },
                },
                i18n: {
                    prev: 'Diapositive précédente',
                    next: 'Diapositive  suivante',
                    first: 'Aller à la première diapositive',
                    last: 'Aller à la dernière diapositive',
                    slideX: 'Aller à la diapositive %s',
                    slideLabel: '%s sur %s',
                    select: 'Sélectionnez une diapositive à afficher',
                },
            };
            this.tabsContentSlider = undefined;
            this.tabsContent = el.querySelector('.onglets__tabscontent');
            this.tabsContent.config = {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                arrows: false,
                pagination: false,
                lazyLoad: 'nearby',
                preloadPages: 1,
                mediaQuery: 'max',
                drag: false,
                easing: 'cubic-bezier(0.25,0.46,0.45,0.94)',
                breakpoints: {
                    640: {
                        perPage: 1,
                        drag: true,
                    },
                },
            };
        }
        init() {
            this.tabsSlider = new Splide(this.tabs, this.tabs.config);
            this.tabsContentSlider = new Splide(this.tabsContent, this.tabsContent.config);
            // this.tabsSlider.sync(this.tabsContentSlider);
            let heightMap = {};
            const tabsContent = this.tabsContent;
            tabsContent.querySelectorAll('.splide__slide').forEach(function (e) {
                e.style.maxHeight = 0;
            });
            this.tabsContentSlider.on('mounted', function () {
                let i = 0;

                tabsContent.querySelectorAll('.splide__slide').forEach(function (
                e) {
                    if (!e.classList.contains('splide__slide--clone')) {
                        heightMap[i] = e.scrollHeight;
                        i++;
                    }
                });
            });
            this.tabsContentSlider.on('active', function (e) {
                let maxHeight = heightMap[e.index] + 1 + 'px';

                e.slide.style.maxHeight = maxHeight;
                e.slide.parentElement.style.maxHeight = maxHeight;
            });

            this.tabsSlider.mount();
            this.tabsContentSlider.mount();

            this.tabsSlider.on('moved', (newIndex) => {
                this.tabsContentSlider.go(newIndex);
            });

            this.tabsContentSlider.on('moved', (newIndex) => {
                this.tabsSlider.go(newIndex);
            });
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        const allSlidersEl = [...document.querySelectorAll('.slider__container')];
        const allFocusEl = [...document.querySelectorAll('.focus__container')];
        const allArticlesEl = [...document.querySelectorAll(
            '.tilesarticles__content-container')];
        const allProduitsEl = [...document.querySelectorAll(
            '.produits__content-container')];
        const allProjetsEl = [...document.querySelectorAll(
            '.tilesprojets__content-container')];
        const allHomeEl = [...document.querySelectorAll('.hero__slides-container')];
        const allMissionsEl = [...document.querySelectorAll(
            '.missions__slides-container')];
        const allQuizzEl = [...document.querySelectorAll(
            '.quizCarousel__slides-container')];
        const allFluxrssEl = [...document.querySelectorAll(
            '.fluxrss__slides-container')];
        const allOngletsEl = [...document.querySelectorAll('.onglets')];

        !!allOngletsEl.length &&
            allOngletsEl.forEach((onglet) => {
                new Onglet(onglet).init();
            });

        if (allSlidersEl.length > 0) {
            for (sliderItem of allSlidersEl) {
                new Slider(sliderItem).init();
            }
        }

        if (allFocusEl.length > 0) {
            for (focusItem of allFocusEl) {
                new FocusSlider(focusItem).init();
            }
        }

        if (allArticlesEl.length > 0) {
            for (articlesItem of allArticlesEl) {
                new ArticlesSlider(articlesItem).init();
            }
        }

        if (allProduitsEl.length > 0) {
            for (produitsItem of allProduitsEl) {
                new ProduitsSlider(produitsItem).init();
            }
        }

        if (allFluxrssEl.length > 0) {
            for (fluxItem of allFluxrssEl) {
                new FluxrssSlider(fluxItem).init();
            }
        }

        if (allProjetsEl.length > 0) {
            for (projetsItem of allProjetsEl) {
                const createProjetsSlider = new ProjetsSlider(projetsItem);
                createProjetsSlider.init();
            }
        }

        if (allHomeEl.length > 0) {
            for (homeItem of allHomeEl) {
                new HomeSlider(homeItem).init();
            }
        }

        if (allMissionsEl.length > 0) {
            for (MissionItem of allMissionsEl) {
                new MissionsSlider(MissionItem).init();
            }
        }
        if (allQuizzEl.length > 0) {
            for (QuizzItem of allQuizzEl) {
                new QuizzSlider(QuizzItem).init();
            }
        }
    });
})();
